

const componentList = require('../../components/component-list/component-list.config');
const componentPagination = require('../../components/component-pagination/component-pagination.config');

module.exports = {
	title: '',
	context: {
		title: 'Lediga Jobb',
		componentList: componentList.context.jobList,
		componentPagination: componentPagination.context
	}
};
